/**
 * Moon & Jade Fortune chat transport contract.
 *
 * This adapter is intentionally inert. It performs no network requests and
 * stores profile context in memory only for the current page session.
 */
(function () {
  'use strict';

  var namespace = window.MoonJadeFortuneChat = window.MoonJadeFortuneChat || {};

  function FortuneChatUnavailableError(message) {
    this.name = 'FortuneChatUnavailableError';
    this.code = 'FORTUNE_CHAT_NOT_CONNECTED';
    this.message = message || 'The Fortune chat service is not connected.';
  }
  FortuneChatUnavailableError.prototype = Object.create(Error.prototype);
  FortuneChatUnavailableError.prototype.constructor = FortuneChatUnavailableError;

  function cloneContext(context) {
    if (!context) return null;
    return JSON.parse(JSON.stringify(context));
  }

  /**
   * Future request shape:
   * {
   *   conversation_id: string | null,
   *   message: string
   * }
   *
   * Raw browser profile context is intentionally excluded from the transport.
   * A future authenticated API may introduce an opaque, server-issued profile
   * reference after consent and ownership checks are implemented.
   *
   * A future response may add streamed text and neutral tool-activity metadata.
   * No VIP, subscription, or entitlement gate exists in this build.
   */
  function FortuneChatService(options) {
    this.options = options || {};
    this.profileContext = null;
    this.supportsStreaming = false;
    this.isConnected = false;
  }

  FortuneChatService.prototype.setProfileContext = function (context) {
    if (!context || context.contract !== 'moon-jade-fortune-profile' || context.version !== 1) {
      this.profileContext = null;
      return;
    }
    this.profileContext = cloneContext(context);
  };

  FortuneChatService.prototype.getProfileContext = function () {
    return cloneContext(this.profileContext);
  };

  FortuneChatService.prototype.clearProfileContext = function () {
    this.profileContext = null;
  };

  FortuneChatService.prototype.createRequest = function (input) {
    input = input || {};
    return {
      conversation_id: input.conversation_id || input.conversationId || null,
      message: String(input.message || '').trim()
    };
  };

  FortuneChatService.prototype.sendMessage = function () {
    return Promise.reject(new FortuneChatUnavailableError());
  };

  namespace.FortuneChatService = FortuneChatService;
  namespace.FortuneChatUnavailableError = FortuneChatUnavailableError;
  namespace.service = namespace.service || new FortuneChatService();

  window.addEventListener('moonjade:fortune-profile', function (event) {
    if (event.detail) namespace.service.setProfileContext(event.detail);
    else namespace.service.clearProfileContext();
  });
})();
